import { RadioGroupField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useEffect, useState } from 'react'

const arePaymentsEnabled = ({
  isPaymentsIntegrationAvailable,
  provider,
  paymentMethodEnabled,
  isStripeConnected,
  isPaypalConnected,
  isStripeDisconnected,
  isPaypalDisconnected,
}) => {
  if (!isPaymentsIntegrationAvailable) {
    return {
      isNoPaymentsEnabled: true,
      isStripeEnabled: paymentMethodEnabled && provider === 'stripe',
      isPaypalEnabled: paymentMethodEnabled && provider === 'paypal'
    }
  }

  if ((paymentMethodEnabled && provider) || isStripeConnected || isPaypalConnected) {
    const isEnabled = isPaymentsIntegrationAvailable

    return {
      isNoPaymentsEnabled: true,
      isStripeEnabled: isEnabled && (isStripeConnected || (paymentMethodEnabled && provider === 'stripe')),
      isPaypalEnabled: isEnabled && (isPaypalConnected || (paymentMethodEnabled && provider === 'paypal'))
    }
  }

  if (isStripeDisconnected || isPaypalDisconnected) {
    return {
      isNoPaymentsEnabled: true,
      isStripeEnabled: isStripeConnected,
      isPaypalEnabled: isPaypalConnected
    }
  }

  return {
    isNoPaymentsEnabled: provider === 'none' && isPaymentsIntegrationAvailable,
    isStripeEnabled: false,
    isPaypalEnabled: false
  }
}

const getProviderOptions = ({
  isNoPaymentsEnabled,
  isStripeEnabled,
  isPaypalEnabled
}) => [{
  name: I18n.t('publisher.event_types.payment_method.do_not_collect_payments'),
  value: 'none',
  disabled: !isNoPaymentsEnabled
}, {
  name: I18n.t('publisher.event_types.payment_method.accept_stripe_payments'),
  value: 'stripe',
  disabled: !isStripeEnabled,
}, {
  name: I18n.t('publisher.event_types.payment_method.accept_paypal_payments'),
  value: 'paypal',
  disabled: !isPaypalEnabled,
}]

// i18n-tasks-use t('publisher.event_types.payment_method.accept_stripe_payments')
// i18n-tasks-use t('publisher.event_types.payment_method.accept_paypal_payments')
export const PaymentOptions = ({
  provider,
  isPaymentsIntegrationAvailable,
  paymentMethodEnabled,
  isStripeConnected,
  isPaypalConnected
}) => {
  const [noPaymentsEnabled, setNoPaymentsEnabled] = useState(false)
  const [stripeEnabled, setStripeEnabled] = useState(false)
  const [paypalEnabled, setPaypalEnabled] = useState(false)
  const isStripeDisconnected = paymentMethodEnabled && provider === 'stripe' && !isStripeConnected
  const isPaypalDisconnected = paymentMethodEnabled && provider === 'paypal' && !isPaypalConnected

  useEffect(() => {
    const {
      isNoPaymentsEnabled,
      isStripeEnabled,
      isPaypalEnabled
    } = arePaymentsEnabled({
      isPaymentsIntegrationAvailable,
      isPaypalConnected,
      isPaypalDisconnected,
      isStripeConnected,
      isStripeDisconnected,
      paymentMethodEnabled,
      provider
    })

    setNoPaymentsEnabled(isNoPaymentsEnabled)
    setStripeEnabled(isStripeEnabled)
    setPaypalEnabled(isPaypalEnabled)
  }, [
    isPaymentsIntegrationAvailable,
    isPaypalConnected,
    isPaypalDisconnected,
    isStripeConnected,
    isStripeDisconnected,
    paymentMethodEnabled,
    provider
  ])

  const providerOptions = getProviderOptions({
    isNoPaymentsEnabled: noPaymentsEnabled,
    isStripeEnabled: stripeEnabled,
    isPaypalEnabled: paypalEnabled
  })

  return (
    <RadioGroupField
      name="provider"
      options={providerOptions}
    />
  )
}
